<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <!-- <el-form-item>
        <el-button
          :loading="downloadLoading"
       
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
          >导出 Excel（数量/ {{ dataList.length }}条）</el-button
        >
      </el-form-item> -->
      <el-form-item
        label="检测机构: "
        style="margin-left:20px"
        v-if="roleId !== 2"
      >
        <el-input
          v-model="selectForm.sup_username"
          placeholder="请输入"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="商品名: " style="margin-left:20px">
        <el-input
          v-model="selectForm.productName"
          placeholder="请输入"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="订单状态: ">
        <el-select v-model="selectForm.state" placeholder="请选择" clearable>
          <div v-for="item in stateList" :key="item.id">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectBtn">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height:75%">
      <el-table
        border
        :data="dataList"
        style="width: 100%;overflow-y: scroll;"
        height="calc(100vh - 220px)"
        v-loading="loading"
   
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="检测机构" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.sup_username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品ID" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.productId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" align="center" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.productName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" align="center" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.openid ? scope.row.openid : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.phone ? scope.row.phone : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center" width="180">
          <template slot-scope="scope">
            <span style="color:red">{{
              scope.row.state == 1
                ? "待邮寄"
                : scope.row.state == 2
                ? "已邮寄"
                : scope.row.state == 3
                ? "已送检"
                : scope.row.state == 4
                ? "检测完成"
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="物流单号" align="center" width="180">
          <template slot-scope="scope">
            <span>{{
              scope.row.logisticsNumber ? scope.row.logisticsNumber : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="检测结果" width="80" align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p style="text-align:center;max-width: 300px;">
                <span style="color: rgb(59, 59, 59);font-weight:600;"
                  >检测结果:</span
                >
                <span style="color:red;font-weight:600">{{
                  scope.row.result ? scope.row.result : "暂无"
                }}</span>
              </p>
              <div slot="reference" class="name-wrapper addressDetail">
                <el-tag size="medium">{{
                  scope.row.result ? "已同步" : "暂无结果"
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="下单时间" width="200" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button size="mini" @click="detailsBtn(scope.row)"
              >详情</el-button
            > -->
            <el-button
              style="margin:10px 0"
              size="mini"
              type="success"
              @click="fahuoBtn(scope.row)"
              v-if="roleId == 2"
              >检测填报</el-button
            >
            <!-- <el-button size="mini" type="danger" @click="fahuoBtn(scope.row)"
              >发货</el-button
            > -->
            <el-button
              size="mini"
              type="danger"
              @click="deleteBtn(scope.row)"
              :disabled="isRole"
              v-if="roleId !== 2"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 产品提交表单 -->
    <el-dialog
      title="检测填报"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="商品名称" :label-width="formLabelWidth">
          <el-input
            v-model="form.productName"
            auto-complete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="订单状态: " style="margin-left:20px">
          <el-select v-model="form.state" placeholder="请选择">
            <el-option
              v-for="item in stateList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="检测结果(请勿输入&特殊字符)"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.result"
            auto-complete="off"
            type="textarea"
            rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectallorder,
  deleteOrder,
  updateOrder,
} from "@/services/niaojian/organizationOrder";
import XLSX from "xlsx";
export default {
  data() {
    return {
      roleId: "",
      selectForm: {},
      downloadLoading: false,
      dataList: [],
      orderDetailArr: [],
      loading: true,
      name: "",
      orderNumber: "",
      phone: "",
      userId: "",
      form: {
        logisticsNumber: "",
      },
      pageCount: "",
      pageSize: 8,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      isRole: false,
      //1待邮寄 2已邮寄 3已送检 4检测完成
      stateList: [
        { id: 1, name: "待邮寄" },
        { id: 2, name: "已邮寄" },
        { id: 3, name: "已送检" },
        { id: 4, name: "检测完成" },
      ],
      formLabelWidth: "100px",
    };
  },
  created() {
    console.log("this.$store.state.supUser", this.$store.state.supUser);
    if (this.$store.state.supUser.roleId == 2) {
      this.selectForm.sup_username = this.$store.state.supUser.sup_username;
      this.roleId = 2;
    }

    this.select();
  },
  methods: {
    select() {
      // 查询订单数据
      selectallorder({
        ...this.selectForm,
        // phone: this.selectForm.phone ? this.selectForm.phone : "1",
      }).then((resp) => {
        this.dataList = resp.data;
        this.loading = false;
      });
    },

    selectBtn() {
      this.select();
    },

    // 发货弹窗
    fahuoBtn(row) {
      
      this.dialogFormVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },
    // 确认修改
    updataLogisticsNumberBtn() {
      // if (this.form.logisticsNumber == "") {
      //   this.$message.error("请填写物流单号");
      //   return;
      // }
    },
    // 提交表单按钮
    updateBtn() {
      console.log("点击了确认", this.form);
      // let { id, name, status, url, sort } = this.form;
      // if (!name|| name) {
      //   this.$message({
      //     type: "info",
      //     message: "请输入分类名称",
      //   });
      //   return;
      // }
      updateOrder(this.form).then((resp) => {

        if (resp.code == 200) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.dialogFormVisible = false;
          this.select();
        }
      });
    },
    deleteBtn(row) {
      this.$confirm("此操作将永久删除该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteOrder(row.id).then((resp) => {
    
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../../vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "id",
          "订单号",
          "姓名",
          "手机号",
          "收货地址",
          "留言",
          "订单总价",
          "物流单号",
          "订单状态(0未发货 1已发货 2已完成 3退款中 4已退款)",
          "商品明细",
          "下单时间",
        ];
        const filterVal = [
          "id",
          "orderNumber",
          "name",
          "phone",
          "address",
          "odescribe",
          "cost",
          "logisticsNumber",
          "state",
          "productList",
          "createTime",
        ];
        const dataList = JSON.parse(JSON.stringify(this.dataList));
        const list = dataList.map((item) => {
          const product = item.productList.map((item2) => {
            return `${item2.productName}(${item2.price}元)X${item2.num}`;
          });
          item.productList = JSON.parse(JSON.stringify(product));
          return {
            ...item,
            productList: item.productList.join(","),
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "订单列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
  },
};
</script>

<style scoped>
.content {
  margin: 10px auto;
  width: 98%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.addressDetail:hover {
  cursor: pointer;
}
</style>
